import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

/**
 * 获取客绑定的用户列表
 * @param {Object} param
 * @param {Object} callback
 */
export function getRoleList(param,callback){
	request({
		method: 'post',
		url: 'GameUser/getRoleList',
		data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 获取客绑定的用户列表
 * @param {Object} param
 * @param {Object} callback
 */
export function getUserList(param,callback){
	request({
		method: 'post',
		url: 'GameUser/getUserList',
		data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}


// 绑定粉丝到游戏用户中
export function bindUser(param,callback){
	request({
			method: 'post',
			url: 'GameUser/bindUser',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 获取当前粉丝的游戏订单信息
 * @param {Object} param
 * @param {Object} callback
 */
export function getOrderList(param,callback){
	request({
		method: 'post',
		url: 'GameUser/getOrderList',
		data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 解绑游戏用户
export function deleteUser(param,callback){
	request({
			method: 'post',
			url: 'GameUser/deleteUser',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}
